// extracted by mini-css-extract-plugin
export default {"root":"FunnelWidgets-root_PVGFU","userWidgetDesktop":"FunnelWidgets-userWidgetDesktop_otGAp","userWidgetMobile":"FunnelWidgets-userWidgetMobile_NqCCv"};